import React, { useState, useEffect } from "react";
import { FaXbox } from "react-icons/fa";
import { AiOutlineAim } from "react-icons/ai";
import { BsGlobe } from "react-icons/bs";
import { BsFillPersonFill } from "react-icons/bs";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import DetailsToggle from "./DetailsToggle";
import Transactions from "./Transactions";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../../axios/AxiosAut";
import { useLocation } from "react-router-dom";
import { setAPIDetailsSupplierTable } from "../../../../redux/slices/statistics/statisticSlice";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch, useSelector } from "react-redux";

import Swal from "sweetalert2";
import "animate.css";
function GeneralDetails() {
  const Navigate = useNavigate();
  const [Toggle, setToggle] = useState("General");
  const location = useLocation();
  const { state } = location;
  const ID = state;
  const [SupplierContacts, setSupplierContacts] = useState();
  const [SupplierDetails, setSupplierDetails] = useState({
    name: "",
    post_code: "",
    city: "",
    email: "",
    country: "",
    street_name: "",
    door_number: "",
    website: "",
    phone_number: "",
    contact: [
      {
        id: "",
        name: "",
        job_role: "",
        phone_number: "",
        email: "",
      },
    ],
  });
  const Permissions = useSelector((state) => state.user.userPermissions);
  const editsupplier = Permissions.find((o) => o.codename === "change_supplier");
  const deletesupplier = Permissions.find((o) => o.codename === "delete_supplier");
  const viewsuppliercontacts = Permissions.find((o) => o.codename === "view_suppliercontact");

  const toggleHandler = () => {
    if (Toggle == "Transactions") {
      setToggle("General");
    } else {
      setToggle("Transactions");
    }
  };
  useEffect(() => {
    //Get details of a supplier
    getAuthorization()
      .get(`company/get_supplier/${ID}`)
      .then((res) => {
        setSupplierDetails(res.data);
        setSupplierContacts(res.data.contact);
      })
      .catch((err) => {
        console.log("Error in getting Supplier details", err);
      });
  }, []);

  const APIDetailsSupplierTable = useSelector(
    (state) => state.statistics.APIDetailsSupplierTable
  );
  const dispatch = useDispatch();

  const getSupplierData=()=>{
    getAuthorization()
    .get("company/all_suppliers/")
    .then((res) => {
      // setCompanySuppliers(res.data);
      dispatch(setAPIDetailsSupplierTable(res.data));
    })
    .catch((err) => {
      console.log("Error in getting suppliers", err);
    });
  }

  const DeleteHandler=()=>{
    getAuthorization().post("company/remove_supplier/", {
      supplier_id: ID
    }).then((res)=>{
      console.log("supplier successfully deleted")
        Swal.fire({
          position: "top-end",
          title: "Supplier Deleted!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
        Navigate("/dashboard/management/supplier-dashboard");
        getSupplierData()
    }).catch((err)=>{
        console.log("error in deleting the supplier")
    })
  }
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Job Role",
        accessor: "job_role",
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Action",
        Cell: (value) => (
          <button>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        ),
      },
    ],
    [SupplierContacts]
  );
  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="w-full">
          <div>
            <div className="flex flex-row space-x-3">
              <h2 className="font-Montserrat text-xl font-bold text-black">
                Supplier details
              </h2>
              <div className="pt-1.5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.38533 2.82133L0.958667 11.2473L0 16L4.75133 15.0413L13.1787 6.61467L9.38533 2.82133ZM2.47267 12.75L1.906 12.1833L9.33333 4.76667L9.89933 5.33267L2.47267 12.75ZM3.81133 14.0887L3.24467 13.522L10.672 6.10533L11.2387 6.672L3.81133 14.0887V14.0887ZM16 3.79267L14.1227 5.67133L10.3287 1.87733L12.206 0L16 3.79267Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
            </div>
            <div className="border-b-2 border-blue-200 w-16"></div>
          </div>
        </div>
      </div>
      <DetailsToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      {Toggle == "General" ? (
        <>
          {" "}
          <div className="flex flex-col space-y-5 w-1/2">
            <div className="mt-3 ml-8">
              <div>
                <div className="flex flex-row space-x-4">
                  <p className="font-Montserrat text-lg font-medium">
                    {SupplierDetails.name}
                  </p>
                </div>
                <div className="flex flex-row space-x-3 mt-6">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="10.0007"
                      cy="10.0007"
                      r="5.00067"
                      stroke="#1F78B4"
                      stroke-width="2"
                    />
                    <path d="M10 4.00044V0" stroke="#1F78B4" stroke-width="2" />
                    <path
                      d="M10 20.0004V16"
                      stroke="#1F78B4"
                      stroke-width="2"
                    />
                    <path
                      d="M20.0037 10L15.2031 10"
                      stroke="#1F78B4"
                      stroke-width="2"
                    />
                    <path
                      d="M4.80053 10L0 10"
                      stroke="#1F78B4"
                      stroke-width="2"
                    />
                    <circle
                      cx="10.0034"
                      cy="10.0034"
                      r="2.30031"
                      fill="#1F78B4"
                      stroke="#1F78B4"
                    />
                  </svg>

                  <p className="font-Roboto text-sm text-gray-600">
                    {SupplierDetails.door_number}, {SupplierDetails.street_name}
                    , {SupplierDetails.post_code}, {SupplierDetails.city},{" "}
                    {SupplierDetails.country}
                  </p>
                </div>
                <div className="flex flex-row space-x-3 mt-4">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM10.8333 13.3808V10.8333H13.3283C13.2792 11.7858 13.1517 12.7 12.9483 13.5658C12.2625 13.4658 11.5533 13.4092 10.8333 13.3808ZM12.4642 15.1825C12.0483 16.2908 11.4983 17.2633 10.8333 18.0625V15.0458C11.3883 15.0692 11.9325 15.1133 12.4642 15.1825ZM10.8333 9.16667V6.65417C11.5567 6.62583 12.2675 6.56833 12.9567 6.4675C13.155 7.32333 13.2808 8.22667 13.3283 9.16667H10.8333ZM10.8333 4.98833V1.9375C11.505 2.745 12.0592 3.72917 12.4758 4.85083C11.9408 4.92083 11.3925 4.965 10.8333 4.98833ZM13.0858 2.26583C14.1167 2.67917 15.0475 3.28917 15.8275 4.05417C15.2925 4.24917 14.735 4.4225 14.145 4.56C13.8583 3.73333 13.4992 2.96833 13.0858 2.26583ZM7.05167 13.5658C6.84833 12.7 6.72 11.7858 6.67167 10.8333H9.16667V13.3808C8.44583 13.4092 7.73833 13.4658 7.05167 13.5658ZM9.16667 15.0458V18.0625C8.50167 17.2633 7.95167 16.2908 7.53583 15.1825C8.0675 15.1133 8.61167 15.0692 9.16667 15.0458ZM6.67167 9.16667C6.71917 8.22667 6.84417 7.32333 7.04333 6.4675C7.7325 6.56833 8.44333 6.62583 9.16667 6.65417V9.16667H6.67167ZM7.525 4.85083C7.94167 3.72917 8.49583 2.745 9.16667 1.9375V4.98833C8.6075 4.965 8.05917 4.92083 7.525 4.85083ZM5.85417 4.55917C5.26417 4.42167 4.70667 4.24833 4.1725 4.05333C4.95333 3.28833 5.88333 2.67833 6.91417 2.265C6.50083 2.96833 6.14167 3.73333 5.85417 4.55917ZM5.39667 6.1575C5.17667 7.11667 5.035 8.12417 4.98667 9.16667H1.70917C1.84667 7.785 2.325 6.5025 3.05667 5.40167C3.79 5.7025 4.57 5.96 5.39667 6.1575ZM5.40417 13.8758C4.58083 14.0725 3.80417 14.3275 3.07333 14.6258C2.33167 13.5192 1.8475 12.2267 1.70917 10.8333H4.9875C5.03583 11.8875 5.18 12.9067 5.40417 13.8758ZM5.865 15.4733C6.15 16.2867 6.505 17.0408 6.9125 17.7333C5.89333 17.325 4.97417 16.7242 4.19917 15.9708C4.72917 15.78 5.28167 15.6083 5.865 15.4733ZM14.135 15.4733C14.7183 15.6092 15.27 15.7792 15.8008 15.9708C15.025 16.7233 14.1058 17.325 13.0867 17.7342C13.4942 17.0408 13.8492 16.2867 14.135 15.4733ZM14.5958 13.8758C14.8208 12.9067 14.9642 11.8875 15.0133 10.8333H18.2917C18.1525 12.2267 17.6683 13.5192 16.9267 14.6258C16.1958 14.3275 15.4183 14.0725 14.5958 13.8758ZM15.0133 9.16667C14.965 8.12417 14.8225 7.11667 14.6033 6.1575C15.43 5.96 16.2108 5.7025 16.9442 5.40167C17.675 6.5025 18.1533 7.785 18.2908 9.16667H15.0133Z"
                      fill="#1F78B4"
                    />
                  </svg>

                  <p className="font-Roboto text-sm text-gray-600">
                    {SupplierDetails.website}
                  </p>
                </div>
                <div className="flex flex-row space-x-3 mt-4">
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9995 22.621L12.4785 15.826C12.4705 15.83 10.5045 16.796 10.4145 16.837C8.17455 17.923 3.61555 9.017 5.80555 7.843L7.88855 6.817L4.39555 0L2.28955 1.039C-4.91245 4.794 6.52255 27.021 13.8895 23.654C14.0105 23.599 15.9915 22.625 15.9995 22.621Z"
                      fill="#1F78B4"
                    />
                  </svg>

                  <p className="font-Roboto text-sm text-gray-600">
                    {SupplierDetails.phone_number}
                  </p>
                </div>
              </div>
              {!viewsuppliercontacts ===undefined ||  viewsuppliercontacts?.codename ===
              "view_suppliercontact" ? (
              <div className="mt-9">
                <p className="font-Montserrat font-semibold text-base text-blue-100">
                  Contacts
                  <div className="border-b-2 border-blue-200 w-7" />
                </p>
              </div>
                  ) : null}

            </div>
          </div>
          {!viewsuppliercontacts ===undefined ||  viewsuppliercontacts?.codename ===
              "view_suppliercontact" ? (
          <div className="">
            <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
              <div className="mt-1">
                <Table
                  columns={columns}
                  data={SupplierContacts == undefined ? [] : SupplierContacts}
                  text="Undefined"
                />
              </div>
            </main>
          </div>
          ) : null}

          <div className="flex flex-row  space-x-144 mx-10 my-10">
            <button
              className="text-red-600 font-Montserrat font-medium text-lg"
              onClick={() =>
                Navigate("/dashboard/warehouse/supplier")
              }
            >
              Go Back
            </button>
           
          </div>
          
        </>
      ) : (
        <Transactions />
      )}
    </>
  );
}

export default GeneralDetails;
